import { Background, CodiItem, Pose, UploadBackground } from "../classes";

const BasicCodiItem = new CodiItem();
const BasicBackground = new Background();
const BasicPose = new Pose();

export { BasicCodiItem, BasicBackground, BasicPose };
